import { AppId } from 'clickNgo/configs/app'
import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { IPartner } from 'clickNgo/entities/partner/models'
import { guid } from 'core/classes/helpers/GuidHelper'

import { ContactStatus, IContact } from '../../model/types'

interface IGetInitialContactData
  extends Pick<
    IPartner,
    | 'partnerId'
    | 'parentPartnerId'
    | 'topPartnerId'
    | 'hierarchyType'
    | 'country'
    | 'market'
    | 'region'
    | 'city'
    | 'countryCode'
    | 'communicationName'
    | 'addressLine1'
    | 'addressLine2'
    | 'addressLine3'
    | 'onboardingRequestId'
    | 'zipCode'
    | 'taxId'
    | 'url'
    | 'email'
  > {}

export const getInitialContactData = ({
  partnerId,
  parentPartnerId,
  topPartnerId,
  hierarchyType,
  country,
  countryCode,
  market,
  region,
  communicationName,
  city,
  addressLine1,
  addressLine2,
  addressLine3,
  taxId,
  zipCode,
  email,
  onboardingRequestId,
  url,
}: IGetInitialContactData): IContact => ({
  addressLine1,
  addressLine2,
  addressLine3,
  appId: AppId.HPScoutSO,
  changeMindset: '',
  city,
  communicationName,
  companyEmail: email,
  competitors: [],
  contactId: `new-${guid()}`,
  contactStatus: '',
  country,
  countryOfBusiness: countryCode,
  createdBy: '',
  email: '',
  emailPixels: null,
  entryId: 0,
  entryId379: 0,
  entryId375: 0,
  facebookLink: '',
  firstName: '',
  gender: '',
  hpPassportProfileId: '',
  hpRoles: [],
  hpdContactGUID: '',
  hpdPartnerGUID: '',
  hierarchyType,
  isGDPR: false,
  isHPChampion: false,
  isHPHero: false,
  isKeyContact: false,
  isNeverCall: false,
  isNeverEmail: false,
  isPPA: false,
  isPreferredContact: false,
  isPrimaryPartner: false,
  isSabaAdmin: false,
  isSabaUser: false,
  jobTitle: '',
  lastContactUpdateDate: '',
  lastName: '',
  lastPartnerUpdateDate: '',
  lastRequest: '',
  learnerId: '',
  linkedInLink: '',
  locationId: '',
  loginId: '',
  mainPhoneCode: '',
  mainPhoneNumber: '',
  market,
  mobilePhoneCode: '',
  mobilePhoneNumber: '',
  modified: '',
  modifiedBy: '',
  modifiedValues: [],
  newContactId: '',
  newPartnerId: '',
  notCorporateEmailReason: '',
  notCorporateEmailReasonComment: '',
  oldContactId: '',
  oldPartnerId: '',
  organization: '',
  onboardingRequestId: onboardingRequestId || undefined,
  parentPartnerId,
  partnerId,
  photo: '',
  portalUserTypeCode: '',
  preferredLanguage: '',
  primaryJobRole: [],
  professionalTitle: '',
  profileTeamComment: '',
  region,
  relationshipStrength: '',
  relinkingComment: '',
  role: '',
  salutation: '',
  seniority: '',
  source: ProfilingRequestSource.ClickAndGoPortal,
  sourceRequester: '',
  status: ContactStatus.None,
  taxId,
  topPartnerId,
  twitterLink: '',
  url,
  userCreatedDate: '',
  userLastLoginDate: '',
  userRowId: '',
  userStatus: '',
  whatsAppLink: '',
  workPhoneCode: '',
  workPhoneNumber: '',
  zipCode,
})
